import { useContext, useCallback } from "react";
import SidebarContext from "./SidebarContext";

/**
 * Hook to manage runtime fields in sidebar (shared across pages but not persisted until save)
 * Similar to useRuntimeField in Wizard
 *
 * @param {string} fieldName - Name of the field
 * @param {*} defaultValue - Default value if field not set
 * @returns {Array} [value, setValue] tuple
 */
const useSidebarField = (fieldName, defaultValue = null) => {
    const { runtimeData, setRuntimeData } = useContext(SidebarContext);

    const value = runtimeData[fieldName] ?? defaultValue;

    const setValue = useCallback(
        (newValue) => {
            setRuntimeData((prev) => ({
                ...prev,
                [fieldName]: newValue,
            }));
        },
        [fieldName, setRuntimeData]
    );

    return [value, setValue];
};

export default useSidebarField;
